// External libraries
import * as React from "react";

// TYpes
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { HotelsFlexComponent } from "components/flexComponents/Hotels/typings";

export const HotelsContext = React.createContext<{
  flexComponent?: HotelsFlexComponent;
  context?: ExtendedContextStore;
}>({});

export function useHotelsContext() {
  const { flexComponent, context } = React.useContext(HotelsContext);

  if (!flexComponent) {
    throw new Error("flexComponent not provided");
  }

  if (!context) {
    throw new Error("context not provided");
  }

  return { flexComponent, context };
}
